export default __webpack_public_path__ + "static/media/authB.e01766c8.jpg";